/** Null or 0 on partner login stats cards. Attendance uses suffix `%`. */
export const displayPartnerStat = (value, suffix = '') => {
  const unit = suffix || '';
  if (value == null || value === 0) return `--${unit}`;
  return `${value}${unit}`;
};
